import React, { PropsWithChildren } from 'react'
import { BackButton } from '@/components/BackButton/BackButton'

interface Props extends PropsWithChildren {
  onGoBack?: () => void
}

export const NavigationHeader: React.FC<Props> = ({ onGoBack, children }) => (
  <header className='flex gap-2 items-center w-full'>
    <BackButton onClick={onGoBack} />
    {children}
  </header>
)
